import $ from 'jquery';
import Swiper, {A11y, FreeMode, Keyboard, Navigation, Pagination} from 'swiper';

const defaultSelectOrElm = '.swiper',
      defaultOptions = {slidesPerView: 1};

export function initSwiper(selectOrElm = defaultSelectOrElm, options = defaultOptions) {
    const $elements = $(selectOrElm);

    if ($elements.length < 1) {
        return;
    }

    const swiper = handleSwiperElements(selectOrElm, options);

    return swiper;
}

function handleSwiperElements(selectOrElm, options = {}) {
    const $selectOrElm = $(selectOrElm);

    if ($selectOrElm.length < 1) {
        return;
    }

    let swiperArray = [],
        swiper = null;

    $selectOrElm.each((index, element) => {
        // init Swiper:
        const swiperEl = new Swiper(element, {
            ...options,

            // configure Swiper to use modules
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets'
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Vorheriger Slide',
                nextSlideMessage: 'Nächster Slide',
            },
        });
        if (index === 0 && $selectOrElm.length === index + 1) {
            swiper = swiperEl
        } else {
            swiperArray.push(swiperEl)
        }
    })

    return swiperArray.length > 0 ? swiperArray : swiper;
}
